'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _tooltip = require('./tooltip.js');

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Waypoint = function Waypoint(map, settings) {
	var _this = this;

	(0, _classCallCheck3.default)(this, Waypoint);

	this.map = map;
	this.settings = settings;
	this.tooltip = null;

	if (this.settings.tooltip_enabled) {
		this.tooltip = new _tooltip2.default({
			'rgba': this.settings.tooltip_background,
			'content': this.settings.tooltip_content,
			'close_behavior': this.settings.tooltip_close
		});
		this.tooltip.node().addClass('route-tooltip');
		this.tooltip.setLeafletMap(map.mapService);
	}

	this.latlng = this.settings.latlng;

	var opts = {
		draggable: false
	};
	if (this.settings.pin_image) {
		opts.icon = L.icon({
			'iconUrl': this.settings.pin_image,
			'iconAnchor': this.settings.pin_anchor
		});
	}
	if (this.settings.pin_enabled) {
		this.marker = L.marker(this.latlng, opts);
		this.map.mapService.addLayer(this.marker);

		if (this.tooltip) {
			this.marker.on('mouseover', function () {
				var anchor = [0, -10];
				if (opts.icon) {
					anchor[1] -= _this.settings.pin_anchor[1];
				} else {
					anchor[1] -= 50;
				}

				var containerPoint = _this.map.mapService.latLngToContainerPoint(_this.latlng);
				var left = _this.map.$container.offset().left + containerPoint.x - Math.ceil(_this.tooltip.node().width() / 2) + anchor[0];
				var top = _this.map.$container.offset().top + containerPoint.y - _this.tooltip.node().height() + anchor[1];
				_this.tooltip.node().trigger({
					'type': 'tooltip_mouseover',
					'settings': {
						'left': left,
						'top': top
					}
				});
			});
			this.marker.on('mouseout', function () {
				_this.tooltip.node().trigger({
					'type': 'tooltip_mouseout'
				});
			});
		}
	}
};

exports.default = Waypoint;


//////////////////
// WEBPACK FOOTER
// ./assets/js/src/public/waypoint.js
// module id = 18
// module chunks = 0